<template>
  <div
    v-if="typeof this.partners !== 'undefined'"
    class="partners"
    :class="{ 'partners--loading': loading }">
    <div class="swiper-products__title"><h3>Partners</h3></div>
    <div class="partners__container" v-if="!loading">
      <img class="partners__background" :src="image">
      <ul>
        <li
          v-for="(partner, index) of partners.fields.image"
          :key="index">
          <img 
            :src="partner.fields.file.url"
            :alt="partner.fields.description"
            :width="partner.fields.file.details.image.width"
            :height="partner.fields.file.details.image.height">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Partners',
  props: {
    image: {
      type: String,
      required: false
    }
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters('contentful', [
      'partners'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadPartners'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadPartners()
        this.loading = false
      } catch (e) {
        
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./partners.scss";
</style>
